/** 複数の API クライアントで共用するユーティリティ。 */
import type { ApiErrorBody } from './types';

export class ApiError extends Error {
  status: number;
  body: ApiErrorBody | undefined;
  constructor(status: number, message: string, body?: ApiErrorBody) {
    super(message);
    // ES5 ターゲットで Error を継承した場合に instanceof が壊れる問題を回避する
    Object.setPrototypeOf(this, ApiError.prototype);
    this.name = 'ApiError';
    this.status = status;
    this.body = body;
  }
}

/** ベース URL とパスを結合する。末尾スラッシュの有無は問わない。 */
export function joinUrl(base: string, path: string): string {
  const trimmedBase = base.endsWith('/') ? base.slice(0, -1) : base;
  const trimmedPath = path.startsWith('/') ? path.slice(1) : path;
  return `${trimmedBase}/${trimmedPath}`;
}
